import { render, staticRenderFns } from "./PostalList.vue?vue&type=template&id=7156f30e&scoped=true&"
import script from "./PostalList.vue?vue&type=script&lang=ts&"
export * from "./PostalList.vue?vue&type=script&lang=ts&"
import style0 from "./PostalList.vue?vue&type=style&index=0&id=7156f30e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7156f30e",
  null
  
)

export default component.exports